import { gql, useQuery, useLazyQuery } from '@apollo/client';
import moment from 'moment';

export const LIST_DOCUMENT_RELATIONSHIP_IDS = gql`
  query documentRelationshipIds($clientId: ID, $policyId: ID, $documentIds: [ID]!, $insuredIds: [ID]) {
    listDocumentRelationshipIds(
      clientId: $clientId
      policyId: $policyId
      documentIds: $documentIds
      insuredIds: $insuredIds
    ) {
      documentRelationshipId
      insuredId
      documentId
    }
  }
`;

export const LIST_DOCUMENT_RELATIONSHIPS_WITHOUT_IDS = gql`
  query documentRelationshipIdsWithoutVersions($ids: [ID]) {
    documentRelationshipIdsWithoutVersions(documentRelationshipIds: $ids)
  }
`;

export default function useListDocumentRelationshipIds({
  policyId,
  clientId,
  documents,
  onCompleted = () => {},
  onError = () => {}
}) {
  const todayFormatted = moment().format(moment.HTML5_FMT.DATE);
  const bulkDocuments = documents?.filter(document => document?.effectiveDate <= todayFormatted);
  const documentIds = bulkDocuments?.map(document => document?.id);

  const [load, { withoutIds, loading: loadingWithout, error: errorWithout }] = useLazyQuery(
    LIST_DOCUMENT_RELATIONSHIPS_WITHOUT_IDS,
    { onCompleted: () => {}, onError: () => {} }
  );

  const { data, loading, error } = useQuery(LIST_DOCUMENT_RELATIONSHIP_IDS, {
    variables: { policyId, documentIds, clientId },
    onCompleted: result => {
      const { listDocumentRelationshipIds } = result;
      const ids = listDocumentRelationshipIds.map(x => x.documentRelationshipId);
      load({ variables: { ids } });
      onCompleted(result);
    },
    onError
  });

  const idsToReject = withoutIds?.documentRelationshipIdsWithoutVersions || [];
  const validList =
    data?.listDocumentRelationshipIds?.filter(x => !idsToReject?.includes(x.documentRelationshipId)) || [];

  const insuredIds = validList.map(x => x.insuredId) || [];
  const documentRelationshipIds = validList?.map(x => x.documentRelationshipId) || [];
  const returnedDocumentIds = validList?.map(x => x.documentId) || [];

  const initialState = {
    allData: validList,
    initialInsuredIds: [...new Set(insuredIds)],
    initialDocumentRelationshipIds: [...new Set(documentRelationshipIds)],
    initialDocumentIds: [...new Set(returnedDocumentIds)],
    initialDocuments: [...new Set(documents)],
    loading: loading || loadingWithout,
    error: error || errorWithout
  };

  return {
    initialState,
    ...initialState,
    loading: loading || loadingWithout,
    error: error || errorWithout
  };
}
